import styled from 'styled-components';

export const StyledWrapper = styled.div`
  width: 700px;
  border-radius: 8px;
  overflow: hidden;
`;
